import React, { Fragment, useRef } from 'react'
import { Button, Grow, MenuItem, MenuList, Paper, Popper } from '@material-ui/core'
import { IMenuItem } from 'hooks/useMenu'
import { Link } from 'components/ui/Behaviors/Link'
import { useStyles } from './MenuListButton.styles'
import { SubMenu } from './SubMenu'

export interface IMenuListButtonProps {
  menuItem: IMenuItem
  isOpen: boolean
  onOpen: (menuItem: IMenuItem) => void
  onClose: (menuItem: IMenuItem) => void
}

export const MenuListButton = ({ menuItem, onOpen, onClose, isOpen }: IMenuListButtonProps) => {
  const classes = useStyles()
  const anchorRef = useRef<HTMLButtonElement>(null)

  const handleOpen = () => {
    onOpen(menuItem)
  }

  const handleClose = () => {
    onClose(menuItem)
  }

  const handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab') {
      event.preventDefault()
      onClose(menuItem)
    }
  }

  const MainMenuItem = ({ subItem }) => (
    <MenuItem className={classes.menuItem}>
      {subItem.isExternalLink === true ? (
        <Link url={subItem.link} openTab={true} onClick={handleClose}>
          {subItem.title}
        </Link>
      ) : (
        <Link route={subItem.link || '/'} onClick={handleClose}>
          {subItem.title}
        </Link>
      )}
    </MenuItem>
  )

  return (
    <>
      <Button
        ref={anchorRef}
        aria-controls="menu-list-grow"
        aria-haspopup="true"
        onTouchStart={() => (isOpen ? handleClose() : handleOpen())}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
        className={`MuiButtonGroup-grouped ${classes.button}`}
        disableRipple={true}
      >
        {menuItem.title}
      </Button>
      <Popper
        onMouseLeave={handleClose}
        onMouseEnter={handleOpen}
        className={classes.popper}
        open={isOpen}
        anchorEl={anchorRef.current}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper square={true}>
              <MenuList autoFocusItem={isOpen} onKeyDown={handleListKeyDown}>
                {menuItem.items &&
                  menuItem.items.map((subItem, index) => (
                    <Fragment key={index}>
                      {subItem.items && subItem.items.length > 0 ? (
                        <SubMenu
                          title={subItem.title}
                          menuItems={subItem.items}
                          isLast={!!menuItem.items && index === menuItem.items?.length - 1}
                        />
                      ) : (
                        <MainMenuItem subItem={subItem} />
                      )}
                    </Fragment>
                  ))}
              </MenuList>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
}
